<template>
  <!-- 输入密码 -->
    <el-dialog
      title="输入密码支付"
      :visible.sync="dialogVisible"
      @close="cancelPassword"
      width="30%"
      class="pass"
      :append-to-body="true"
      id="orderlist"
    >
      <div>
        <el-input
          style="width: 100%"
          v-model="verificationCode"
          placeholder="请输入支付密码"
          maxlength="6"
          show-password
          autocomplete="new-password"
          class="default-input"
        ></el-input>
        <!-- :type="passwordType" -->
        <!-- <svg
          class="icon"
          aria-hidden="true"
          v-show="icon && passwordType == 'password'"
          @click="passType(passwordType)"
        >
          <use xlink:href="#icontanchuang_guanbichakan" />
        </svg>
        <svg
          class="icon"
          aria-hidden="true"
          v-show="icon && passwordType == 'text'"
          @click="passType(passwordType)"
        >
          <use xlink:href="#icontanchuang_chakn" />
        </svg> -->
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="priceMarkup()"
          :disabled="!verificationCode"
          :loading="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      dialogVisible: false,
      verificationCode:'',
      loading:false
    }
  },
  methods: {
    // 取消密码输入
    cancelPassword() {
      this.verificationCode = "";
    },
    priceMarkup(){
      this.$emit('ok',this.verificationCode)
      this.dialogVisible=false
    },
  }
}
</script>

<style lang='scss' scoped>

</style>
